<script setup>
    import { reactive, watch } from 'vue'
    import Error from "../../firebase_settings/error.js"
    import { useRoute } from 'vue-router'
    import utilFunctions from "../../firebase_settings/utils.js"

    const route = useRoute()
    const emit = defineEmits(['executeMethod']);
    const props = defineProps({
        otherObject: {
            type: Object,
            require: true
        },
    });
    //パスワードの値を保持するリアクティブオブジェクト
    const reactiveObj = reactive({
        //登録する企業名
        corporateName: "",
        //担当者名
        userName: "",
        //登録する企業コード
        corporateId: "",
        //登録する管理者のメールアドレス
        adminEmail: "",
        //登録する契約担当者のメールアドレス
        contractEmail: "",
        //契約担当者と管理者のメールアドレス同一可否
        duplicateFlag: true,
        //加入プラン名
        planValue: 0,
        //月額(1)or年額(12)
        payment: 1
    })
    //全ての入力フォームが入力されたときに変更ボタンを活性化させる
    const inputSomeData = () => {
        //変更ボタンの活性化フラグ
        let equalFlag = false
        //全ての入力フォームが入力されたときに変更ボタンの活性化フラグをTrueにする
        if(
            reactiveObj.corporateName &&
            reactiveObj.userName &&
            reactiveObj.corporateId &&
            reactiveObj.contractEmail &&
            (!reactiveObj.duplicateFlag && reactiveObj.contractEmail || reactiveObj.duplicateFlag)
        ) {
            equalFlag = true
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag ? document.getElementById('commonButtonAdd').disabled = false: document.getElementById('commonButtonAdd').disabled = true
    }
    //リアクティブオブジェクトのリセット
    const valueReset = () => {
        reactiveObj.corporateName = ''
        reactiveObj.userName = ''
        reactiveObj.corporateId = ''
        reactiveObj.adminEmail = ''
        reactiveObj.contractEmail = ''
        reactiveObj.duplicateFlag = true
        reactiveObj.planValue = 0
        reactiveObj.payment = 1
    }
    //先頭文字の大文字判定
    const isUpperCase = (str) => {
        const arr = str.match(/^[A-Z]+$/)
        return arr ? true : false
    }
    const exitModal = async(addFlag) => {
        if(addFlag) {
            //メールアドレスを正規表現でチェック
            if(!utilFunctions.mailValidation(reactiveObj.contractEmail)) {
                return
            }
            if(!reactiveObj.duplicateFlag && !utilFunctions.mailValidation(reactiveObj.adminEmail)) {
                return
            }
            //企業コードを正規表現でチェック（半角英数字のみ）
            if (!reactiveObj.corporateId.match(/^[A-Za-z0-9]*$/)) {
                alert(Error.errorResult({ code: 'ACE0002' }, route.name))
                return
            }
            //企業コードの頭文字を大文字に変換する
            if(!isUpperCase(reactiveObj.corporateId)) {
                reactiveObj.corporateId = reactiveObj.corporateId.charAt(0).toUpperCase() + reactiveObj.corporateId.slice(1);
            }
            if(reactiveObj.duplicateFlag) {
                reactiveObj.adminEmail = reactiveObj.contractEmail
            }
            //企業コードの重複確認
            let duplicateFlag = false
            for(let corporateId of props.otherObject.corporateIdList) {
                if(corporateId == reactiveObj.corporateId) {
                    duplicateFlag = true
                    break
                }
            }
            //企業コードの重複チェック
            if(duplicateFlag) {
                alert(Error.errorResult({ code: 'ACE0003' }, route.name))
                return
            }
        }
        //親コンポーネントに編集の是非とその値を渡す
        emit('executeMethod', addFlag, reactiveObj);
        //モーダルウィンドウを閉じる際に追加ボタンを非活性化
        document.getElementById('commonButtonAdd').disabled = true;
        //値のリセット
        valueReset()
    }
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
</script>

<template>
    <div class="modalArea">
        <div id="modalContent" class="modal">
            <p class="modalTitle">企業情報の追加</p>
            <div class="modalInfo">
                <p>企業名</p>
                <input type="text" class="modalInput" v-model="reactiveObj.corporateName" placeholder="株式会社">
            </div>
            <div class="modalInfo">
                <p>企業コード（半角英数字のみ）</p>
                <input type="text" class="modalInput" v-model="reactiveObj.corporateId" placeholder="CorporateName">
            </div>
            <div class="modalInfo">
                <p>契約担当者名</p>
                <input type="text" class="modalInput" v-model="reactiveObj.userName" placeholder="担当者名">
            </div>
            <div class="modalInfo">
                <p>契約担当者のメールアドレス</p>
                <input type="text" class="modalInput" v-model="reactiveObj.contractEmail" placeholder="aaa@cotofure.com">
            </div>
            <div class="modalInfo">
                <p>料金プラン</p>
                <select class="modalInput" v-model.number="reactiveObj.planValue">
                    <option value="0">Test</option>
                    <option value="1">Light</option>
                    <option value="2">Standard</option>
                    <option value="3">Pro</option>
                    <option value="4">Business</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>月払い/年払い</p>
                <select class="modalInput" v-model.number="reactiveObj.payment">
                    <option value="1">月払い</option>
                    <option value="12">年払い</option>
                </select>
            </div>
            <div class="modalInfo">
                <p>契約担当者と管理者の<br>メールアドレスを同一にする</p>
                <div class="switchArea">
                    <p class="switchLabel" v-if = "reactiveObj.duplicateFlag">する</p>
                    <p class="switchLabel" v-else>しない</p>
                    <label>
                        <input type="checkbox" v-model="reactiveObj.duplicateFlag">
                        <div id="swImg"></div>
                    </label>
                </div>
            </div>
            <div class="modalInfo" v-show="!reactiveObj.duplicateFlag">
                <p>管理者のメールアドレス</p>
                <input type="text" class="modalInput" v-model="reactiveObj.adminEmail" placeholder="aaa@cotofure.com">
            </div>
            <button type="button" id="commonButtonAdd" @click="exitModal(true)" disabled>追加する</button>
        </div>
        <div class="modalOverlay" @click.self="exitModal(false)"></div>
    </div>
</template>

<style scoped>
    .modal {
        width: 800px;
        height: 600px;
        top: 50%;
        left: 50%;
        overflow-y: scroll;
    }
    #commonButtonAdd {
        width: 190px;
        height: 70px;
        top: 30px;
        left: 50%;
    }
    .modalInfo {
        display: flex;
        flex-direction: row;
        padding: 0 3% 0 3%;
    }
    .modalInput {
        height: 50px;
        width: 500%;
        border-radius: 10px;
        border: solid 3px #d7d7d7;
        background-color: #d7d7d7;
    }
    .switchArea {
        width: 350%;
        height: 100%;
        left: 0%;
        p {
            left: -60px;
            width: 50px;
            text-align: center;
        }
    }
    @media (max-width: 1000px) {
        .modal {
            width: 85%;
            height: 700px;
            display: flex;
            justify-content: left;
            align-items: left;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .modal p {
            padding: 10px 0 10px 0;
        }
        .modalInfo {
            flex-direction: column;
            padding: 3% 0 3% 0;
        }
        .modalInfo p {
            top: 0%;
            width: 100%;
            max-width: 100%;
            font-size: 16px;
        }
        .modalInput {
            height: 50px;
            width: 100%;
            border-radius: 10px;
            border: solid 3px #d7d7d7;
            background-color: #d7d7d7;
        }
        #commonButtonAdd {
            margin: 20px 0 20px 0;
            top: 30px;
            height: auto;
        }
        .switchArea {
            width: calc(100% - 50px);
            height: 50px;
            left: calc(50px);
            p {
                width: 50px;
                height: 50px;
            }
        }
    }
</style>